import { ApiProject } from "../types/projects.types";
import { ProjectNode } from "../types/ProjectTree";

export function adaptProjectsToTree(apiProjects: ApiProject[]): ProjectNode[] {
  return apiProjects.map((p) => ({
    id: p.id,
    label: p.name,
    phases: (p.phases ?? []).map((ph) => ({
      id: ph.id,
      label: ph.name,

      blocks: (ph.blocks ?? []).map((b) => ({
        id: b.id,
        label: b.name,

        stages: (b.breakdowns ?? []).map((br) => ({
          id: br.id,
          label: br.name,
        })),
      })),
    })),
  }));
}

export function adaptProjectStub(p: ApiProject): ProjectNode {
  return {
    id: p.id,
    label: p.name,
    phases: [],
  };
}
